

















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import CreateEmailTemplateRequest from '@/models/EmailTemplates/CreateEmailTemplateRequest';
import ListUtils from '@/lib/listUtils';
import EmailTemplateType from '@/models/EmailTemplates/EmailTemplateType';
import EmailTemplateViewModel from '@/models/EmailTemplates/EmailTemplateViewModel';
import EmailIntegrationTemplateDto from '@/models/EmailIntegrationTemplates/EmailIntegrationTemplateDto';

@Component({
    name: 'EmailTemplateCreate'
})
export default class extends GiganautVueDialog {
 
  public entity = new EmailTemplateViewModel();


  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.entity = new EmailTemplateViewModel();
    }
  }

  @Watch('entity.selectedEmailIntegrationTemplate')
  onSelectedEmailIntegrationTemplateChanged(val: EmailIntegrationTemplateDto, oldVal: EmailIntegrationTemplateDto) {
    if (val) {
      this.entity.name = val.name;
      this.entity.templateId = val.id;
    }
  }

  get templateTypes() {
    return ListUtils.emailTemplateTypes();
  }

  get emailIntegrationTemplates() {
    return AgencySettingsModule.emailIntegrationTemplates;
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }


  async save() {
     if (!(this.$refs.form as any).validate()) {
      return;
    }

    const request = new CreateEmailTemplateRequest()
    request.name = this.entity.name;
    request.type = this.entity.type;
    request.templateId = this.entity.templateId;
    await AgencySettingsModule.createEmailTemplate(request);
    this.dialog = false;
  }
}
